import { Input } from "@material-ui/core";
import React from "react";
import { BaseProps, Field } from "./field";

type Props = BaseProps<string> & {
  maxLength?: number;
  placeholder?: string;
  rows?: number;
  rowsMax?: number;
};

export const Textarea: React.FC<Props> = (props) => {
  function onChange(event: React.ChangeEvent<HTMLInputElement>): void {
    if (props.onChange) {
      props.onChange(props.name, event.target.value);
    }
  }

  return (
    <Field
      label={props.label}
      required={props.required}
      error={props.error}
      disabled={props.disabled}
      size={props.size}
    >
      <Input
        disabled={props.disabled}
        error={!!props.error}
        inputProps={{
          maxLength: props.maxLength,
        }}
        multiline
        name={props.name}
        onChange={onChange}
        placeholder={props.placeholder || ""}
        required={props.required}
        rows={props.rows}
        rowsMax={props.rowsMax}
        value={props.value || ""}
      />
    </Field>
  );
};
